/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';
import AchievementCategoryDesc from '../../../common/components/AchievementCategoryDesc';
import AchievementCategoriesDropdown from './AchievementCategoriesDropdown';

export default class AchievementsHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { category, loading, achievement_categories } = this.attrs;

		return (
			<div className="Hero">
				<div className="AchievementsHero">
					{!loading &&
						category && [
							<h1 className="Hero-title">
								<AchievementCategoryName category={category} />
								<AchievementCategoriesDropdown achievement_categories={achievement_categories} categoryId={category.id()} />
							</h1>,
							<div className="Hero-subtitle">
								<AchievementCategoryDesc category={category} />
							</div>,
						]}
				</div>
			</div>
		);
	}
}
